import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';

type Props = {
  items: ArticleCardType[];
};

export default function Tiles({ items }: Props) {
  const [card1, card2, card3, card4, card5, card6] = items;
  if (!card1 || !card2 || !card3 || !card4 || !card5 || !card6) return null;

  return (
    <div className="w-full bg-grey-tile">
      <div className="no-scrollbar mx-auto flex max-w-desktop gap-6 overflow-x-scroll px-4 py-10 md:py-20 lg:px-0">
        <div className="flex flex-1 flex-col gap-6">
          <ArticleCard
            item={card1}
            name="LATEST_NEWS"
            pagePosition="Homepage Article Tiles"
            variant="4/5-text-over"
          />
          <ArticleCard
            item={card2}
            name="LATEST_NEWS"
            options={{ oneLineTitle: true }}
            pagePosition="Homepage Article Tiles"
            variant="16/9-text-under"
          />
        </div>
        <div className="flex flex-1 flex-col gap-6">
          <ArticleCard
            item={card3}
            name="LATEST_NEWS"
            options={{ oneLineTitle: true }}
            pagePosition="Homepage Article Tiles"
            variant="16/9-text-under"
          />
          <ArticleCard
            item={card4}
            name="LATEST_NEWS"
            pagePosition="Homepage Article Tiles"
            variant="4/5-text-over"
          />
        </div>
        <div className="flex flex-1 flex-col gap-6">
          <ArticleCard
            item={card5}
            name="LATEST_NEWS"
            pagePosition="Homepage Article Tiles"
            variant="4/5-text-over"
          />
          <ArticleCard
            item={card6}
            name="LATEST_NEWS"
            options={{ oneLineTitle: true }}
            pagePosition="Homepage Article Tiles"
            variant="16/9-text-under"
          />
        </div>
      </div>
    </div>
  );
}
